module.exports = __webpack_public_path__ + "static/media/html-original.a13daaa1.mp4";